import { useEffect, useState } from "react";
import {
  getTextAlignmentValue,
  getTextAlignmentClassName,
} from "../utils/langUtil";

function useTextAlignment(text: string) {
  const [textAlignment, setTextAlignment] = useState({
    value: getTextAlignmentValue(text),
    className: getTextAlignmentClassName(text),
  });

  useEffect(() => {
    setTextAlignment({
      value: getTextAlignmentValue(text),
      className: getTextAlignmentClassName(text),
    });
  }, [text]);

  return textAlignment;
}

export default useTextAlignment;
